import React from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../Styles/yellocalfcss/PrintInvoice.css"; 

const PrintInvoice = () => {
  return (
    <Container fluid className="p-4 PrintInvoice-container">
      <Row>
        <Col className="d-flex justify-content-between">
          <div><b>Generated By: stage.edsys.in</b></div>
          <div><b>Generated On: Thu, 18 Sep 2025 15:20:29 +0530</b></div>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col className="text-center">
          <img
            src="https://via.placeholder.com/120x40"
            alt="logo"
            className="mb-2"
          />
          <div>Sharjah - United Arab Emirates, 9446636724, newschool@mailinator.com</div>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <h5>hi parents</h5>
        </Col>
      </Row>

      <hr />

      <Row className="border p-3 mt-3">
        <Col md={6}>
          <p><b>Admission No:</b> fsdf35346</p>
          <p><b>Name:</b> ASHUTOSE</p>
          <p><b>Grade:</b> SEVENTH</p>
        </Col>
        <Col md={6}>
          <p><b>Academic Year:</b> 2020-2021</p>
          <p><b>Date:</b> 10 Jun 2024</p>
          <p><b>Due Date:</b> 10 Jun 2024</p>
          <p><b>Division:</b> F</p>
          <p><b>Invoice No:</b> IN-1782</p>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <Table bordered className="PrintInvoice-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Particulars</th>
                <th>Terms/Semester</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>
                  Arrears <br />
                  Arrear Discount <br />
                  Additional Charges
                </td>
                <td></td>
                <td>
                  $ 4000 <br />
                  $ 350 <br />
                  $ 50
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  Sub Total <br />
                  Discount <br />
                  Tax/Additional Charges <br />
                  Grand Total <br />
                  Paid Amount
                </td>
                <td></td>
                <td>
                  $ 4000 <br />
                  $ 350 <br />
                  $ 50 <br />
                  $ 3700 <br />
                  $ 0
                </td>
              </tr>
              <tr>
                <td></td>
                <td><b>Balance</b></td>
                <td></td>
                <td><b>$ 3700</b></td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col>
          Balance is Three thousand seven hundred $ Only.
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <h6>hai testing</h6>
        </Col>
      </Row>
    </Container>
  );
};

export default PrintInvoice;
